import axios, { baseUrl } from './axios';
import queryString from 'query-string';

export default {
  loadProjectIdentificationList: async (options = {}) => {
    const params = queryString.stringify(
      Object.assign(
        {
          offset: options.offset,
          limit: options.limit,
        },
        options.filter,
      ),
    );

    //if user login not have selectedOrganisationId, this filer will undefind
    //this filter is selectedOrganisationId just get resource, not filter by oganization
    const result = await axios.get(
      `${baseUrl}/customer/mob/organisations/${options.currentCompany ||
        options.organisationId}/project_identifications${
        params ? `?${params}` : ''
      }`,
    );
    return result.data;
  },

  loadProjectIdentificationDetail: async data => {
    const result = await axios.get(
      `${baseUrl}/customer/mob/organisations/${
        data.organisationId
      }/project_identifications/${data.projectIdentificationId}`,
    );
    return result.data;
  },

  createProjectIdentification: async data => {
    const result = await axios.post(
      `${baseUrl}/customer/mob/organisations/${
        data.organisationId
      }/project_identifications`,
      data,
    );
    return result.data;
  },

  updateProjectIdentification: async data => {
    const result = await axios.put(
      `${baseUrl}/customer/mob/organisations/${data.organisationId ||
        data.organisationObject.key}/project_identifications/${data.id}`,
      data,
    );
    return result.data;
  },
};
